import Header from 'pages/landing/common/Header/Header';
import About from './About/About';
import Story from './Story/Story';
import Experts from './Experts/Experts';
import Vision from './Vision/Vision';
import Footer from 'pages/landing/common/Footer/Footer';

function AboutUsPage() {
  return (
    <main>
      <Header role="default" />
      <About />
      <Story />
      <Experts />
      <Vision />
      <Footer />
    </main>
  );
}

export default AboutUsPage;
